import {
  // cancel, fork,
  call, put,
  select, take,
} from 'redux-saga/effects';

import { MainHubSubmitStakeError, SubmitStakePayload } from './types';
import type { SagaIterator } from '@redux-saga/types';

import { mainHubInstance, nextDialogId, subscribeToDialogResponse } from 'app/lib/signalr';

import { submitStakeRequest, submitStakeSuccess } from '../../actions/submission';
// import { addInBlockedStakesQueue, deleteFromBlockedStakesQueue } from '../../actions/waitingInQueue';
import { selectSubmissionPreferences } from '../../selectors';
// import { selectWaitingInQueue } from '../../selectors/waitingInQueue';
import { createDefaultResponseError, createFailureAction } from './errors';

// ---

// TODO: перенести в mainHub.submitStake
type MainHubSubmitStakeResponse = {
  stakeId: number;
  winning: number;
  stakePrice: number;
  error?: MainHubSubmitStakeError;
};

// ---

/**
 * Transform the "submit stake response" to action.
 */
function transformResponseToAction(
  dialogId: string,
  response: MainHubSubmitStakeResponse,
  requestPayload?: SubmitStakePayload,
) {
  if (response?.error) { // submission failed
    return createFailureAction(dialogId, response.error, requestPayload);
  }

  const { stakeId, winning, stakePrice } = response;

  return submitStakeSuccess({
    dialogId,
    requestPayload,
    stakeId,
    winning,
    stakePrice,
  });
}

// ---

export function* subscribeToBigStakeResponse(dialogId: string): SagaIterator {
  const channel = yield call(subscribeToDialogResponse, 'fix-stake-response', dialogId);

  let response;

  try {
    response = yield take(channel);
  }
  catch (error) {
    response = createDefaultResponseError();
    console.error('submitStake error', error);
  }
  finally {
    channel.close();
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore // TODO: Понятия не имею, как добавить сюда правильный тип
  yield put(transformResponseToAction(dialogId, response));
}

// ---
//Закоменнтировано в сязи с переходом на новое флоу при совершениие крупной ставки
// function* waitingInQueueNotification(dialogId: string): SagaIterator {
//   const channel = yield call(subscribeToDialogResponse, 'waiting-in-queue-notification', dialogId);
//
//   try {
//     const stake = yield take(channel);
//
//     yield put(addInBlockedStakesQueue(stake.dialogId));
//   }
//
//   catch (error) {
//     console.error('waitingInQueueNotification error', error);
//   }
//   finally {
//     channel.close();
//   }
// }
//
// function* bigStakeNotification(dialogId: string, requestPayload: SubmitStakePayload): SagaIterator {
//   const channel = yield call(subscribeToDialogResponse, 'active-big-stake-notification', dialogId);
//
//   try {
//     const stake = yield take(channel);
//
//     yield put(addBigStake({ requestPayload, stake }));
//   }
//   catch (error) {
//     console.error('bigStakeNotification error', error);
//   }
//   finally {
//     channel.close();
//   }
// }

// ---

export function* submitStake(payload: SubmitStakePayload): SagaIterator {
  const dialogId = nextDialogId();

  yield put(submitStakeRequest({ ...payload, dialogId }));

  const preferences = yield select(selectSubmissionPreferences);

  const channel = yield call(subscribeToDialogResponse, 'fix-stake-response', dialogId);
  //Закоменнтировано в сязи с переходом на новое флоу при совершениие крупной ставки
  // const notificationChannel = yield fork(bigStakeNotification, dialogId, payload);
  // const waitingInQueueChanel = yield fork(waitingInQueueNotification, dialogId);

  let response;

  try {
    const data = { dialogId, preferences, betSlip: payload };

    const hubInstance = mainHubInstance.tryToGetHub();
    yield call([hubInstance, hubInstance.send], 'fixStake', data);

    while (true) {
      response = yield take(channel);
    }
  }
  catch (_error) {
    response = createDefaultResponseError();
  }
  finally {
    //Закоменнтировано в сязи с переходом на новое флоу при совершениие крупной ставки
    // yield cancel(notificationChannel);
    // yield cancel(waitingInQueueChanel);
    channel.close();
    //Закоменнтировано в сязи с переходом на новое флоу при совершениие крупной ставки
    // const queue = yield select(selectWaitingInQueue);
    //
    // if (queue.has(dialogId)) {
    //   yield put(deleteFromBlockedStakesQueue(dialogId));
    // }

    const responseAction = transformResponseToAction(dialogId, response, payload);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore // TODO: Понятия не имею, как добавить сюда правильный тип
    yield put(responseAction);
  }
}
